export default __webpack_public_path__ + "images/ebc796a3bbe0163eb19f4d6b6de0bda4-motorsports_small.webp";